import { store } from './state/store'
import { DropScreen } from './ui/DropScreen'
import { Header } from './ui/Header'
import { Headline } from './ui/Headline'
import { Chart } from './ui/Chart'
import { EditIsland } from './ui/EditIsland'
import { StatCards } from './ui/StatCards'
import { HeartRateCard } from './ui/HeartRateCard'
import { StintTable } from './ui/StintTable'
import { RecordsTable } from './ui/RecordsTable'
import { LengthsTable } from './ui/LengthsTable'
import { exportViolations } from './ui/uiState'

function ErrorBanner() {
  const message = store.error.value
  if (!message) return null
  return (
    <div class="violations" role="alert">
      <div style="display:flex; align-items:flex-start; gap:10px">
        <div style="flex:1">
          <h3>Couldn't open that file</h3>
          {message}
        </div>
        <button class="btn" onClick={() => store.clearError()}>
          Dismiss
        </button>
      </div>
    </div>
  )
}

function ViolationPanel() {
  const violations = exportViolations.value
  if (violations.length === 0) return null
  return (
    <div class="violations">
      <h3>Export blocked — {violations.length} problem(s)</h3>
      <ul>
        {violations.map((v, i) => (
          <li key={i}>
            <strong>{v.check}</strong>: {v.detail}
          </li>
        ))}
      </ul>
    </div>
  )
}

export function App() {
  if (!store.hasActivity.value) return <DropScreen />
  return (
    <>
      <Header />
      <div class="page">
        <ErrorBanner />
        <ViolationPanel />
        <Headline />
        <Chart />
        <EditIsland />
        <div class="lower">
          <StintTable />
          <div class="right-col">
            <StatCards />
            <HeartRateCard />
            <RecordsTable />
          </div>
        </div>
        <LengthsTable />
      </div>
    </>
  )
}
